import { useState } from "react";
import Button from "../../../UI/Button";
import styles from "./Header.module.css";
import WhatIs from "./WhatIs";

export default function Header({ title, description, button }) {
  const [whatIs, setWhatIs] = useState(false);

  return (
    <>
      {whatIs && (
        <WhatIs
          onClose={() => {
            setWhatIs(false);
          }}
        />
      )}
      <main className={styles.main}>
        <div className={styles.title}>{title}</div>
        <div className={styles[`title-underline`]} />
        <div className={styles.description}>{description}</div>
        <div className={styles.button}>
          <Button
            onClick={() => {
              setWhatIs(true);
            }}
          >
            {button}
          </Button>
        </div>
      </main>
    </>
  );
}
